import { render } from "./IconSortDown.vue?vue&type=template&id=34b18ed6"
import script from "./IconSortDown.vue?vue&type=script&lang=js"
export * from "./IconSortDown.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__